import { observer } from 'mobx-react-lite'
import { ReactElement } from 'react'
import { useUiStateStore } from '../../../../../src/store/uiState/UiStateStore'
import BaseDrawer from 'src/ui-components/modals/BaseDrawer'
import { Grid } from '@mui/material'
import styled from 'styled-components'
import { Translate2 } from 'common'
import { Button } from '../../../../../src/ui-components/forms/Button'
import { defaultTheme } from '../../../../../src/theme/index'
import { useResultsStore } from '../../store/ResultsStore'
import { breakpoints } from '../../../../../src/theme/breakpoints'
import { ArrowForwardIos } from '@mui/icons-material'

export const SelectPartsCatalogDiagramDrawer = observer((): ReactElement => {
  const {
    showPartsCatalogDiagramDrawer,
    setShowPartsCatalogDiagramDrawer,
    setShowDetailCatalogDiagram,
  } = useUiStateStore()

  const { setSelectedCatalogDiagram, diagrams: diagramsResult } =
    useResultsStore()
  const diagrams = diagramsResult?.parts

  const bodyDrawer = diagrams?.map((diagram, index) => {
    return (
      <DiagramGrid
        key={diagram.allianceProductId}
        container
        className={index === 0 ? 'first-grid' : ''}
      >
        <DesktopOnly>
          <Grid item xs={8}>
            <StyledText>
              {Translate2('diagram')} #: {diagram.partNumber}
            </StyledText>
          </Grid>
          <Grid item xs={4}>
            <Button
              onClick={() => {
                setSelectedCatalogDiagram(diagram)
                setShowPartsCatalogDiagramDrawer(false)
                setShowDetailCatalogDiagram(true)
              }}
              variant="primary"
              size="large"
              text={Translate2('select')}
            />
          </Grid>
        </DesktopOnly>
        <MobileOnly>
          <SpaceBetweenRow
            onClick={() => {
              setSelectedCatalogDiagram(diagram)
              setShowPartsCatalogDiagramDrawer(false)
              setShowDetailCatalogDiagram(true)
            }}
          >
            <div>
              <StyledText>
                {Translate2('diagram')} #: {diagram.partNumber}
              </StyledText>
            </div>
            <div>
              <StyledArrowForwardIos />
            </div>
          </SpaceBetweenRow>
        </MobileOnly>
      </DiagramGrid>
    )
  })

  return (
    <BaseDrawer
      showHeaderDivider
      body={bodyDrawer}
      onClose={() => setShowPartsCatalogDiagramDrawer(false)}
      open={showPartsCatalogDiagramDrawer}
      title="diagrams"
      height="500px"
    />
  )
})

const StyledText = styled.span`
  font-family: 'Oswald', serif;
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
`

const DiagramGrid = styled(Grid)`
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${defaultTheme.colors.border};
  padding: 10px 26px 26px 10px;
  margin-top: 1px;
  height: auto;

  &.first-grid {
    padding-top: 10px;
  }
`

const MobileOnly = styled.div`
  display: none;
  width: 100%;
  @media screen and (max-width: ${breakpoints.laptop}px) {
    display: block;
  }
`

const DesktopOnly = styled.div`
  display: flex;
  width: 100%;
  @media screen and (max-width: ${breakpoints.laptop}px) {
    display: none;
  }
  @media print {
    display: none;
  }
`

const StyledArrowForwardIos = styled(ArrowForwardIos)`
  color: #adadaa;
  font-size: 14px;
  font-weight: bold;
`

const SpaceBetweenRow = styled.div`
  display: flex;
  justify-content: space-between;
`
